import * as VKID from '@vkid/sdk';
import { VKID_REDIRECT_URL } from '@/config';

export const setupVKID = () => {
    const APP_ID = import.meta.env.VITE_VKID_APP_ID;
    const REDIRECT_URL = VKID_REDIRECT_URL;

    VKID.Config.set({
        app: APP_ID,
        redirectUrl: REDIRECT_URL,
    });
};

export default setupVKID;
